import { Check_log_value, Endtest, evaluate_user } from './../../services/endtest.service';
import { Component, OnInit, Input, Inject, HostListener, ViewChild, TemplateRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { faBrain, faBookOpen, faBook, faCaretRight, faCaretLeft } from '@fortawesome/free-solid-svg-icons';
import { SectionService } from 'src/app/services/section.service';
import { endtestService } from 'src/app/services/endtest.service';
import { formatDate } from '@angular/common';
import { Category } from '../category';
import { Router } from '@angular/router';
import 'es6-promise/auto';
import { questionService, User_Time ,Section_Time , Local} from 'src/app/services/question.service';
import { SwiperOptions } from 'swiper';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { AudioRecordingService } from '../../audio-recording.service';

/**
 * switch target DOMElement to fullscreen mode.
 * @param element {Element} DOMElement that you want to make fullscreen.
 */

// import { Component, OnInit } from '@angular/core';
declare var $: any;
declare let jQuery: any;
@Component({
  selector: 'app-ttsection',
  templateUrl: './ttsection.component.html',
  styleUrls: ['./ttsection.component.scss']

})
export class ttsectionComponent implements OnInit {
  @ViewChild("content") modalContent: TemplateRef<any>;
  @ViewChild("endtestmodal") modalEndtest: TemplateRef<any>;
  elem;
  check_loggedin :Check_log_value ={
    Test_Taker_User_Id :'',
    schedule_id:''
  }
  toggleClass = 'ft-minimize';
  eee: boolean;
  screenWidth: number | undefined;
  screenHeight: number | undefined;
  //public config: any = {};
  endtest: any;
  button_click: number;
  arr: any = [];
  start_button: any = [];
  isCustomStyleApplied: boolean = false;
  end_button: any[];
  section_button: any = [];
  section_button1: any = [];
  section_color: any = [];
  user_id: evaluate_user = {
    id: ''
  };
  islogged: Endtest = {
    Id: '',
    Test_Taker_User_Id: '',
    Is_Logged: '',
    login_time: '',
    logoff_time: '',
    schedule_master_Id:''
  };
  user_time: User_Time = { login_time: '', logoff_time: '' }
  today = new Date();
  todaysDataTime = '';
  logged: boolean = false;
  clicked = false;
  category: Category = {
    id: ''


  };
  Question_Section: any;
  length1: number;
  tempp: any = []
  end: any;
  @Input() greetMessage: string;
  start = [];
  datas: [];
  setid: any;
  paperid: any;
  questions: any;
  arr1: any;
  item: boolean = false;
  btnDisabled: boolean = false;
  editmode = true;
  duration: any;
  categoryduration: any = [];
  len: boolean;
  logoff_button: string;
  user_loggoff_time: string;
  user_logon_time: string;
  category_counter: any;
  category_count: any;
  n: any;
  zero: number = 0;
  sectioncounter: any;
  sectioncount: any;
  pagealive: number;
  section_collection: any = [];
  section_collection_counter: number =0;
  sectionpush: any =[];
  currentSection: any ;
  userId: string;
  isReload: false;
  compArray=[]
  displayQuestionsArray=[]
  comprehensionQuestionsArray=[]
  totalQuestions:number;
  local: Local = { Id: '', paper: '', set: '', schedule: '', email: '', schedule_master_Id: '' };
  section_time: Section_Time = { start_time: '', end_time: '', section_name: '', user_id: '' , email: '' , category_id:''}
  constructor(@Inject(DOCUMENT) private document: any, private modal: NgbModal, private quest: questionService,private videorecord: AudioRecordingService ,private evaluate_user: endtestService, private router: Router, private section: SectionService, private Endtest: endtestService) {

  }
  recordingdata:boolean;
  time = new Date()
  categoryCompletionTracker={}
 
  ngOnInit() {
  
    this.getScreenSize();
    this.applyStylesBasedOnResolution();
    this.elem = document.documentElement;
    this.pagealive=1
    this.pagealive=JSON.parse(localStorage.getItem('pagealive'))
    this.sectionpush =JSON.parse(localStorage.getItem('sectionpush'));
    this.section_collection_counter = JSON.parse(localStorage.getItem('section_collection_counter'));

    this.category.id = sessionStorage.getItem('id')
	this.userId = sessionStorage.getItem('id')
  console.log("sessionStorage.getItem('id')",sessionStorage.getItem('id'))

  console.log("this.category.id",this.category.id)

  this.section
  .categoryCompletionTracker(Number(this.category.id))
  .subscribe((data) => {
    console.log("Category Completion Tracker", data);

    if (!Array.isArray(data) || data.length === 0) {
      return;
    }

    // Track completed sections
    const completedSectionNames: string[] = [];

    data.forEach(category => {
      // Track completion status
      this.categoryCompletionTracker[category.Section_Id] =
        category.is_completed;

      if (category.is_completed) {
        completedSectionNames.push(category.Section_Name);
      }
    });

    // Remove completed sections in ONE pass
    this.sectionpush = this.sectionpush.filter(
      sectionName => !completedSectionNames.includes(sectionName)
    );

  });


    this.section.category(this.category).subscribe(
      (data) => {
        console.log("sections fetched from db",data.results)

        this.Question_Section = data.results;
        console.log( this.Question_Section)
        
        this.length1 = this.Question_Section.length
        for(var i=0;i<this.length1;i++){
          this.section_collection.push(this.Question_Section[i].Section_Name)
        }

        this.category_counter = this.Question_Section.length
        this.n = JSON.parse(localStorage.getItem('on_load_counter'));
        this.sectioncount = JSON.parse(sessionStorage.getItem('section_collection_counter'));
        //alert(this.sectioncount)
        // if (this.n === null) {
        //   this.n = 0;
        // }

        // this.n++;

        // localStorage.setItem("on_load_counter", JSON.stringify(this.n));



        if (this.n === this.category_counter) {

          let ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false
          };


          //Open modal on pressing escape
          const modalRef = this.modal.open(this.modalContent, ngbModalOptions)




          //alert(this.category_counter)
          if (this.section_collection_counter == this.category_counter) {
            this.final();
          }
          // if (this.buttonclick == false) {
          //
          //   modalRef.close(this.modalContent)
          //   this.router.navigateByUrl('final');
          // }


        }
        if (this.length1 > 6) {
          this.len = true
        }
        else {
          this.len = false
        }
        for (var j = 0; j < this.length1; j++) {
          this.categoryduration[j] = this.Question_Section[j].Section_Id
        }




        this.user_id = this.Question_Section[0].Id;


        for (var i = 0; i < this.length1; i++) {
          this.tempp[this.Question_Section[i].Section_Id] = localStorage.getItem('targetSection' + this.Question_Section[i].Section_Id);
          this.arr[this.Question_Section[i].Section_Id] = localStorage.getItem('section_button' + this.Question_Section[i].Section_Id);
          console.log("this.category.id",this.category.id)
          console.log("this.Question_Section[i]",this.Question_Section[i])
          console.log("this.Question_Section[i].Section_Id",this.Question_Section[i].Section_Id)
          this.currentSection = localStorage.getItem(`${this.category.id}[${this.Question_Section[i].Section_Id}]`)
      console.log("currentSection***********",this.currentSection)    
      if( this.currentSection == 'completed')
          {
            this.end = 1;
          }
        }






        for (var i = 0; i < this.length1; i++) {




          if (this.tempp[this.Question_Section[i].Section_Id] == 0) {
            this.end = 1;
          }

          if (this.arr[this.Question_Section[i].Section_Id] == 0) {

            this.section_color[this.Question_Section[i].Section_Id] = 1

          }

        }



        return this.Question_Section;
      },
      err => {
        console.error(err);
      }
    );

    


    // this.Categoryduration();
    jQuery(document).ready(function ($) {
      if(navigator.userAgent.indexOf("Firefox") != -1 )
      {
        if (window.history && window.history.pushState) {

          $(window).on('popstate', function () {
            var hashLocation = location.hash;
            var hashSplit = hashLocation.split("#!/");
            var hashName = hashSplit[1];

            if (hashName !== '') {
              var hash = window.location.hash;
            }
          });
          window.history.pushState('/', null, './');
        }
    }
    });

  

  }
 
  getScreenSize(): void {
    this.screenWidth = window.innerWidth;
   
    this.screenHeight = window.innerHeight;
    
  }

  applyStylesBasedOnResolution(): void {
    if (this.screenWidth && this.screenHeight) {
      
      if (this.screenWidth < 1366 && this.screenHeight < 768) {
        this.isCustomStyleApplied = true;
        
      
      }
     
    }
  }


  faBrain = faBrain;
  faBook = faBook;
  faBookOpen = faBookOpen;
  faCaretRight = faCaretRight;
  faCaretLeft = faCaretLeft;

  //   data(){
  //     this.section.category(this.category).subscribe(
  //       (data) => {
  //

  //        this.Question_Section = data.results;
  //
  //        return this.Question_Section;
  //       },
  //       err => {
  //         console.error(err);
  //       }
  //     );
  //   }

  // Categoryduration(){
  //   this.section.duration(this.categoryduration).subscribe(
  //     data => {
  //       this.duration = data.results;
  //
  //     });
  // }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }
  @HostListener('window:popstate', ['$event'])
  onBrowserBackBtnClose(event: Event) {


    event.preventDefault();
   // window.history.forward();
    this.router.navigate(['/'], { replaceUrl: true });
    return false;
  }
 
  // Fixed visibility methods in ttsection.component.ts

changecolor(row) {
  let color;
  if (this.categoryCompletionTracker[row.Section_Id] == 1) {
    color = 'green';
  }
  return color;
}

change_visibility(row, i) {
  let visibility;
  if (this.categoryCompletionTracker[row.Section_Id] == 1) {
    visibility = 'hidden';
  } else {
    visibility = 'visible'; // Changed from 'null' to 'visible'
  }
  return visibility;
}

changeVisibility(row) {
  let visibility;
  if (this.categoryCompletionTracker[row.Section_Id] == 1) {
    visibility = 'visible'; // Changed from 'null' to 'visible'
  } else {
    visibility = 'hidden';
  }
  return visibility;
}

  start_time(row) {
   // this.todaysDataTime = formatDate(this.today, 'hh:mm:ss', 'en-US', '+0530');
    var now = moment().format("hh:mm:ss");

    this.start_button = now

    sessionStorage.setItem('Start_Time', this.start_button)
   // sessionStorage.setItem('StartTime', this.time)

  }

  // changestartcolor(){
  //   visibility:hidden;
  //   pointer-event:none;
  // }
  fetchData(){

    this.check_loggedin.Test_Taker_User_Id = sessionStorage.getItem('id');
    this.check_loggedin.schedule_id = sessionStorage.getItem('Schedule_Id');
    //
    this.Endtest.checkisLogged(this.check_loggedin).subscribe(

       data => {

         if(data.results[0].Is_terminated=='YES'){
           clearInterval(this.intervalId);
           //this.modalCafe.close(this.modalContent)
           this.endfinaltest()
           this.router.navigateByUrl('final');


         }


       },
       err => {
         //console.error(err);

       }

     );
   }
  intervalId = setInterval(() =>{
    this.fetchData()
  },10000);


  onselect(row) {
    console.log("inside onselect section")

    localStorage.setItem("display_name", row.Section_Name);
    localStorage.setItem("categoryduration", row.Duration);
    clearInterval(this.intervalId);
    this.item = true;
    this.btnDisabled = true;
    this.editmode = false;
    this.start_time(row);



    //counter to get count of answered sections, to process end test modal
    this.section_collection_counter = this.section_collection_counter + 1;
    localStorage.setItem("section_collection_counter",JSON.stringify(this.section_collection_counter))

    //if (this.section_collection.includes(row.section_name)){

      if(this.section_collection_counter>1){
        this.section_collection =JSON.parse(localStorage.getItem('sectionpush'));
    }
      const index: number = this.section_collection.indexOf(row.Section_Name);

      this.section_collection.splice(index, 1);
//}
console.log("section_collection",this.section_collection)

   // this.sectionpush.push(this.section_collection)
    localStorage.setItem("sectionpush",JSON.stringify(this.section_collection))

    if (this.n === null) {
      this.n = 0;
    }

    this.n++;

    localStorage.setItem("on_load_counter", JSON.stringify(this.n));
    // event.target.disabled = true;
    //
    // if(event.target.value){}

    //  this.arr[row.Section_Id]=true
    // this.changecolor(row);

    localStorage.setItem('Category-id', row.Section_Id);
    localStorage.setItem('Section_Name', row.Section_Name);

    for (var i = 0; i < this.length1; i++) {
      if (row.Section_Id == this.Question_Section[i].Section_Id) {
        this.setid = this.Question_Section[i].Question_Set_id;

        this.paperid = this.Question_Section[i].Question_Paper_Id;

        localStorage.setItem('Set-id', this.setid);
        localStorage.setItem('Paper-id', this.paperid);
      }
    }

    this.local.Id = row.Section_Id;
    this.local.set = sessionStorage.getItem('Set_Id')
    this.local.paper = sessionStorage.getItem('Paper_Id')
    this.local.schedule = sessionStorage.getItem('Schedule_Id')
    this.local.email = sessionStorage.getItem('email')
    this.local.schedule_master_Id = sessionStorage.getItem('Schedule_Master_Id');
    

    // console.log(this.questions[0].type_name)
    this.start.push(row.Section_Id)
    // this.toggleFullScreen();
    this.time.getTime();
    // console.log(this.time)
    // if (this.questions[0].type_name == 'Algorithm') {
      // this.router.navigate(['test', row.Section_Id]);
      // console.log("1algo");

    // }
    
    console.log(this.local);
    this.quest.displayQuestion(this.local).subscribe(
      data => {
        this.questions = data.results;
        console.log("DATSA************************",data);
        if (this.questions[0].type_name == 'Media') {
          this.router.navigate(['urltest', row.Section_Id]);
        }
        // else if(this.questions[0].type_name == 'AudioAnswer'){
        //   this.router.navigate(['record', row.Section_Id]);
        // }
        else if(this.questions[0].type_name == 'VideoAnswer' || this.questions[0].type_name == 'AudioAnswer'){
          this.router.navigate(['videorecord', row.Section_Id]);
        }
        else{
          console.log("ys");
          this.router.navigate(['test', row.Section_Id]);
        }

      }
      );
    
    

    // if (this.questions[0].type_name == 'Algorithm') {
      // this.router.navigateByUrl('/question_set');
    // }
    // else{
    // this.router.navigate(['test', row.Section_Id]);
    // }
    this.openFullscreen();

    this.section_time.end_time = null
    this.section_time.start_time = sessionStorage.getItem('Start_Time')
    this.section_time.section_name = localStorage.getItem('Section_Name');
    this.section_time.user_id = sessionStorage.getItem('id')
    this.section_time.email = sessionStorage.getItem('email')
    this.section_time.category_id = localStorage.getItem('Category-id');
    // console.log(this.section_time.email);
    // console.log(this.section_time.user_id);
    // console.log(this.section_time.section_name);
    // console.log(this.section_time.end_time);
    // console.log(this.section_time.category_id);
    this.sectiontime();



  }
   
  async sectiontime() {
    // alert("sendtime")
    this.quest.section_time(this.section_time).subscribe(
      async data => {

      },

      err => {
        //console.error(err);

      }
    )
      ;
  }


  openFullscreen() {
    let color
    color = 'white';
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
      backdrop: false;
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }


  }
 

  open_endtestmodal(){

console.log("section_collection_counter",this.section_collection_counter,this.category_counter)
    
    
    if(this.section_collection_counter != this.category_counter){
      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false
      };


      //Open modal on pressing escape
      const modalRef = this.modal.open(this.modalEndtest, ngbModalOptions)

    }
    else{
      this.endfinaltest()
    }

  }

  endfinaltest() {

    //modalRef.close(this.modalKeyboard)
    clearInterval(this.intervalId);
    localStorage.setItem('on_load_counter', JSON.stringify(this.zero));
    this.n = 0;
    localStorage.setItem("section_counter", JSON.stringify(this.zero));
    if(this.section_collection_counter != this.category_counter) {
      //alert('Not answered all sections')

      this.user_logon_time = localStorage.getItem('Logon time');
      this.todaysDataTime = formatDate(this.today, 'hh:mm:ss', 'en-US', '+0530');

      //
      // this.logoff_button = this.todaysDataTime
      this.user_loggoff_time = this.todaysDataTime

      this.islogged.login_time = this.user_logon_time;
      this.islogged.logoff_time = this.user_loggoff_time;
      var schedule_master = sessionStorage.getItem('Schedule_Master_Id')

      this.Endtest.endtest(this.islogged,this.userId,schedule_master).subscribe(

        data1 => {

          this.logged = true;
          this.evaluate()
        //   localStorage.clear();
        // sessionStorage.clear();

        },
        err => {
          //console.error(err);

        }

      );
    }

    this.router.navigate(['final']);
    //sessionStorage.removeItem('sectionpush')
    //sessionStorage.removeItem('section_collection_counter')
  }

  final() {
    //this.end_time()
    clearInterval(this.intervalId);
    localStorage.setItem('on_load_counter', JSON.stringify(this.zero));
    this.n = 0;
    localStorage.setItem("section_counter", JSON.stringify(this.zero));
    // alert(this.zero)
    //alert("Inside final")
    // alert(localStorage.setItem('on_load_counter',JSON.stringify(this.zero)))



    this.user_logon_time = localStorage.getItem('Logon time');
    var now = moment().format("hh:mm:ss");

    //
    //this.logoff_button = this.todaysDataTime
    this.user_loggoff_time = now

    this.islogged.login_time = this.user_logon_time;
    this.islogged.logoff_time = this.user_loggoff_time;
    var schedule_master = sessionStorage.getItem('Schedule_Master_Id')

    this.Endtest.endtest(this.islogged,this.userId,schedule_master).subscribe(

      data1 => {

        this.logged = true;
        this.evaluate()
        // localStorage.clear();
        // sessionStorage.clear();

      },
      err => {
        //console.error(err);

      }

    );
    sessionStorage.removeItem('sectionpush')
    sessionStorage.removeItem('section_collection_counter')

  }

  evaluate() {
    console.log("this.local",this.local,sessionStorage.getItem('Schedule_Id'))
   var schedule_id = sessionStorage.getItem('Schedule_Id')
    this.evaluate_user.evaluate(this.userId,schedule_id).subscribe(

      data => {

        //this.end_time();
      },
      err => {
        //console.error(err);

      }

    );
  }

  // end_time() {

  //   this.quest.save_user_time(this.user_time).subscribe(
  //     async data => {
  //
  //     },
  //      err => {
  //       //console.error(err);
  //
  //     }
  //   );
  // }


  config: SwiperOptions = {
    //  pagination: { el: '.swiper-pagination', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    // spaceBetween: 30,
    // autoplay: true,
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 3,
   
    slidesPerColumn: 1.5, 
      slidesPerColumnFill: 'row',
     setWrapperSize: true,
    // speed: 400,
    autoHeight: true,
     speed: 1500,
    parallax: !0,
    // autoplay: true,
    //loop: !0,
    direction: "horizontal"
    
    //loop: true

  };
  
}

const blobToBase64 = blob => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};


function stopBothVideoAndAudio(stream) {
  stream.getTracks().forEach(function(track) {
      if (track.readyState == 'live') {
          track.stop();
      }
  });
}



